import HelpIcon from "@mui/icons-material/Help";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useJoyride } from "../../context/JoyrideContext";
import SignOut from "../../features/auth/signOut";
import { LangSwitcher } from "../lang-switcher";

function TopMenu() {
	const { t } = useTranslation();
	const { startJoyride } = useJoyride();

	return (
		<>
			<AppBar
				position="sticky"
				sx={{
					background: "#F2F2F2",
					boxShadow: "none",
					height: "49px",
				}}
			>
				<Toolbar
					sx={{ display: "flex", justifyContent: "end", position: "relative" }}
					variant="dense"
				>
					<Box sx={{ mr: "20px" }}>
						<LangSwitcher />
					</Box>
					<SignOut />
					<Tooltip
						title={
							<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
								{t("show_tour_guide")}
							</Typography>
						}
						placement="bottom"
					>
						<IconButton
							aria-label="guide"
							size="small"
							onClick={startJoyride}
							sx={{ ml: "20px" }}
						>
							<HelpIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Toolbar>
			</AppBar>
		</>
	);
}
export default TopMenu;
